




// import React from "react";
// import "../css-coding/mainHome.css";
// import phoneVideo from "../assets/DESKTOP HEAD.mp4";   // desktop background video
// import mobileVideo from "../assets/MOBILE HEAD.mp4";   // mobile background video

// const HomeSection = () => {
//   return (
//     <div className="hero-container">
//       {/* Desktop background video */}
//       <video
//         className="phone-bg desktop-phone"
//         src={phoneVideo}
//         autoPlay
//         loop
//         muted
//         playsInline
//       />

//       {/* Mobile background video */}
//       <video
//         className="phone-bg mobile-phone"
//         src={mobileVideo}
//         autoPlay
//         loop
//         muted
//         playsInline
//       />
//     </div>
//   );
// };

// export default HomeSection;



import React from "react";
import "../css-coding/mainHome.css";
import phoneVideo from "../assets/DESKTOP HEAD.mp4";   // desktop video
import mobileVideo from "../assets/MOBILE HEAD.mp4";   // mobile video

const HomeSection = () => {
  return (
    <div className="client-hero-container">
      {/* Desktop Video */}
      <video
        className="hero-video desktop-video"
        src={phoneVideo}
        autoPlay
        loop
        muted
        playsInline
        controls={false}
      />

      {/* Mobile Video */}
      <video
        className="hero-video mobile-video"
        src={mobileVideo}
        autoPlay
        loop
        muted
        playsInline
        controls={false}
      />
    </div>
  );
};

export default HomeSection;
